export const articles = [
  {
    id: "a1",
    title: "某古装剧组夜戏路透流出，双主角同框画面引全网讨论",
    category: "娱乐八卦",
    categorySlug: "yule",
    excerpt:
      "一段十几秒的夜戏路透在深夜悄悄流传，画面里两位主角的对手戏被网友反复切片分析，讨论量在两小时内翻了三倍。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20ancient%20chinese%20drama%20night%20scene%20with%20lantern%20glow%20and%20misty%20courtyard%2C%20deep%20red%20and%20golden%20amber%20lighting%2C%20cinematic%20magazine%20poster%20style%2C%20soft%20film%20grain%2C%20no%20people&width=800&height=450&seq=chigua-art-01&orientation=landscape",
    heat: 286.4,
    publishedAt: "2026-09-14 09:20",
    author: "吃瓜观察员",
    source: "52吃瓜网综合整理",
    tags: ["古装剧", "路透", "剧组动态"],
    isTop: true,
    content: [
      "今天凌晨一点左右，一段标注为某古装剧组的夜戏路透开始在多个社交平台流传。画面时长不足二十秒，但两位主演在灯影下的对手戏被网友逐帧截图，相关话题在两小时内讨论量翻了三倍。",
      "从流出的画面看，场景布置在一座仿古庭院，屋檐下挂着成排的暖色灯笼，地面有淡淡的水雾。摄制组显然做了保密处理，画面边缘能看到遮挡用的挡板，因此不少网友判断这是路人偶然拍到的片段。",
      "截至发稿，剧组官方暂未对这段路透作出回应。有参与过现场的工作人员在评论区留言，称当晚拍摄的是一场情绪浓度较高的重头戏，反复拍了很多条，主演状态一直在线。",
      "值得注意的是，这已经不是该剧组第一次出现路透。上个月中旬，一组白天外景照也曾在网上流传，当时讨论的焦点集中在服装造型是否符合朝代设定上，而这一次，网友的关注点明显转向了两位主角的化学反应。",
      "有影视行业从业者提醒，路透片段往往经过了剪辑和调色，与最终成片效果存在差距，建议观众以正式物料为准。不过从目前的热度来看，这部剧的期待值已经被提前拉满。",
    ],
  },
  {
    id: "a2",
    title: "头部主播深夜直播宣布调整节奏，粉丝群刷屏追问原因",
    category: "网红动态",
    categorySlug: "wanghong",
    excerpt:
      "一场原本普通的带货直播在接近尾声时画风突变，主播突然聊起自己的状态，宣布将放缓更新频率，直播间弹幕瞬间刷屏。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20live%20streaming%20studio%20at%20night%20with%20glowing%20ring%20light%20and%20blurred%20notification%20bubbles%2C%20coral%20pink%20and%20amber%20gradient%20glow%2C%20modern%20editorial%20poster%20style%2C%20clean%20minimal%20composition%2C%20no%20people&width=800&height=450&seq=chigua-art-02&orientation=landscape",
    heat: 341.8,
    publishedAt: "2026-09-14 07:45",
    author: "瓜田记录",
    source: "52吃瓜网综合整理",
    tags: ["直播", "带货", "主播动态"],
    isTop: true,
    content: [
      "昨夜十一点半，一场持续了四个多小时的直播在尾声阶段出现转折。主播在介绍完最后一件商品后，没有像往常一样直接下播，而是放下手里的提词卡，和观众聊起了最近的状态。",
      "直播中他提到，高强度的日播让自己很难有时间沉淀内容，接下来会把更新频率从每天一场调整为每周三场，同时减少一部分非核心的商务合作。话音刚落，直播间弹幕几乎被问号刷屏。",
      "有长期关注他的观众表示，这个决定其实早有征兆。近一个月里，他的直播时长明显缩短，选品也偏向更熟悉的品类，甚至在几场直播中主动提到希望把更多时间留给团队。",
      "截至发稿，其所在机构尚未发布正式说明。多位接近团队的人士在社交平台上表示，这次调整属于正常的节奏优化，并非外界猜测的合作破裂或账号变动。",
      "对带货行业来说，头部主播的节奏变化往往会牵动一批商家的排期。有品牌方在社群中透露，已经收到后续合作时间调整的通知，正在重新协调大促期间的资源投放。",
    ],
  },
  {
    id: "a3",
    title: "老城区惊现“会唱歌”的旧墙，居民围观后才发现真相",
    category: "社会奇闻",
    categorySlug: "shehui",
    excerpt:
      "一面普通的老墙每到傍晚就会传出旋律，附近居民越传越玄，直到有人蹲守了三个晚上，才把谜底揭开。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20old%20city%20alley%20wall%20at%20dusk%20with%20warm%20window%20glow%20and%20floating%20dust%20particles%2C%20teal%20green%20shadows%20with%20amber%20highlights%2C%20documentary%20poster%20aesthetic%2C%20soft%20grain%2C%20no%20people&width=800&height=450&seq=chigua-art-03&orientation=landscape",
    heat: 97.6,
    publishedAt: "2026-09-13 21:10",
    author: "社区观察",
    source: "52吃瓜网综合整理",
    tags: ["奇闻", "生活", "城市见闻"],
    content: [
      "过去一周，某老城区的一条小巷成了附近居民的打卡点。据说每到傍晚六点左右，巷尾那面斑驳的旧墙就会传出若有若无的旋律，最先发现的是每天在此遛弯的几位老人。",
      "传言越传越玄，有人说墙里埋过老式收音机，也有人开玩笑说这是“会唱歌的墙”。短视频平台上，相关内容的播放量几天内突破百万，巷子口的煎饼摊生意都好了不少。",
      "真相其实并不复杂。一位住在附近的年轻人连续蹲守了三个晚上，终于找到声音的来源——墙后是一户人家的老式音响，因为管道和砖墙的共振，声音被传了出来，听起来就像从墙里发出的。",
      "这位年轻人把发现过程拍成视频发布后，评论区一片“原来如此”。有意思的是，不少邻居表示，知道了真相反而有点遗憾，大家更怀念那几天一起猜谜的热闹气氛。",
      "社区工作人员表示，欢迎居民用这种轻松的方式关注身边的环境，同时也提醒大家拍摄时注意通行安全，不要长时间占用巷道影响正常出行。",
    ],
  },
  {
    id: "a4",
    title: "这档慢综艺为何突然口碑逆袭？三个细节被观众反复截图",
    category: "影视综",
    categorySlug: "yingshi",
    excerpt:
      "开播时被吐槽节奏太慢，播到中段却悄悄爬上讨论榜前列。观众整理的三个细节，道出了它反转的原因。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20cozy%20countryside%20variety%20show%20scene%20with%20soft%20morning%20light%20and%20rustic%20wooden%20textures%2C%20warm%20cream%20and%20forest%20green%20palette%2C%20editorial%20magazine%20style%2C%20gentle%20film%20grain%2C%20no%20people&width=800&height=450&seq=chigua-art-04&orientation=landscape",
    heat: 128.3,
    publishedAt: "2026-09-13 18:30",
    author: "剧综点评组",
    source: "52吃瓜网综合整理",
    tags: ["综艺", "口碑", "名场面"],
    content: [
      "这档主打慢节奏的综艺开播时并不被看好，前两期因为剪辑偏平、笑点分散，弹幕里“劝退”的声音不少。但进入中段后，它在多个平台的讨论量稳步上升，评分也悄悄爬了回来。",
      "观众整理的第一个细节是“不抢戏”。节目组明显减少了对嘉宾反应的刻意放大，很多有趣的瞬间来自自然流露，反而让画面更有生活质感。",
      "第二个细节是“留白”。每期结尾都会保留一段没有任何旁白和配乐的画面，只有环境声。有观众表示，正是这几分钟让自己愿意一集不落地追下去。",
      "第三个细节是“连贯性”。节目把几期内容串成了一条完整的时间线，人物关系在推进中逐渐清晰，而不是每期重新开始。这种处理让追更的观众有了连续的情感投入。",
      "有媒体分析认为，慢综艺的口碑曲线通常前低后高，关键在于能否在平淡的日常里找到稳定的叙事支点。从目前的反馈看，这档节目找到了属于自己的节奏。",
    ],
  },
  {
    id: "a5",
    title: "两人被拍到同逛家居店，工作室暂未回应恋爱传闻",
    category: "情侣纪事",
    categorySlug: "qinglv",
    excerpt:
      "一组生活化路透在周末流出，画面里的两人挑选餐具、挑选地毯，动作自然。传闻发酵一天后，双方均未正面回应。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20warm%20home%20furnishing%20store%20interior%20with%20soft%20lamp%20glow%20and%20blurred%20shelves%2C%20peach%20coral%20and%20golden%20cream%20tones%2C%20dreamy%20editorial%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20no%20people&width=800&height=450&seq=chigua-art-05&orientation=landscape",
    heat: 176.5,
    publishedAt: "2026-09-13 14:05",
    author: "瓜田记录",
    source: "52吃瓜网综合整理",
    tags: ["恋爱传闻", "路透", "同框"],
    content: [
      "上周末，一组拍摄于某家居卖场的生活化照片在网络流传。画面中的两人推着购物车挑选餐具和地毯，全程没有刻意遮掩，动作看起来相当自然。",
      "由于两人此前在合作作品中有过多次联袂出演，粉丝对这张同框并不意外，讨论的重心很快从“是否同框”转向了“关系是否更进一步”。",
      "截至发稿，双方工作室均未对相关传闻作出正面回应。此前面对类似传闻时，双方的惯例是既不承认也不否认，仅表示希望外界多关注作品本身。",
      "值得留意的是，照片中出现的卖场当天人流量并不小，却直到数日后才被整理发布，有网友据此推测是刻意延后曝光。不过这一说法并未得到任何证实。",
      "对于恋情类话题，业内人士提醒，同框照片只能说明两人在同一时间出现在同一地点，并不足以证明更多内容，建议以官方信息为准，理性吃瓜。",
    ],
  },
  {
    id: "a6",
    title: "音乐节后台花絮曝光，歌手临场改歌单的原因浮出水面",
    category: "娱乐八卦",
    categorySlug: "yule",
    excerpt:
      "原定的开场曲临时被换掉，现场观众直到安可环节才明白原因。后台花絮流出后，这段故事看哭了不少人。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20music%20festival%20stage%20at%20night%20with%20glowing%20light%20beams%20and%20crowd%20bokeh%2C%20coral%20red%20and%20golden%20amber%20gradient%20lighting%2C%20energetic%20concert%20poster%20style%2C%20soft%20grain%2C%20no%20identifiable%20people&width=800&height=450&seq=chigua-art-06&orientation=landscape",
    heat: 154.2,
    publishedAt: "2026-09-12 22:40",
    author: "现场记录员",
    source: "52吃瓜网综合整理",
    tags: ["音乐节", "现场", "歌单"],
    content: [
      "在上周末的一场音乐节上，这位歌手的演出出现了小小的意外：原本排在开场的曲目被临时换成了另一首节奏更慢的歌，现场观众一开始还有些没反应过来。",
      "演出结束后，一段后台花絮被曝光。画面里，工作人员正在核对歌单，歌手犹豫了几秒，说想把开场换成那首写给家乡的歌，因为当天刚好收到了一条来自老家的消息。",
      "这个原因直到安可环节才被歌手本人含糊地提起。他说，有些歌不是想唱就能唱好，要等到情绪刚好合适。台下的观众用整齐的合唱回应了这句话。",
      "不少到场的观众在社交平台分享了感受，认为临时改歌单反而成了整场演出最难忘的部分。也有人提到，这种临场感正是现场演出区别于录音室作品的价值所在。",
      "从传播效果看，这段花絮的热度甚至超过了演出本身。有乐评人表示，观众现在更在意舞台背后的真实情绪，而不只是一场完美的表演。",
    ],
  },
  {
    id: "a7",
    title: "短视频博主道歉视频登上热搜，评论区意见两极",
    category: "网红动态",
    categorySlug: "wanghong",
    excerpt:
      "一条时长六分钟的道歉视频把这位博主推上热搜第一，但评论区的态度并没有因此统一，支持和质疑各占一半。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20smartphone%20recording%20setup%20with%20soft%20studio%20light%20and%20floating%20comment%20bubbles%2C%20teal%20green%20and%20coral%20red%20accents%20on%20cream%20background%2C%20modern%20editorial%20poster%20style%2C%20no%20people&width=800&height=450&seq=chigua-art-07&orientation=landscape",
    heat: 219.7,
    publishedAt: "2026-09-12 16:20",
    author: "瓜田记录",
    source: "52吃瓜网综合整理",
    tags: ["道歉", "热搜", "争议"],
    content: [
      "前天傍晚，这位博主发布了一条六分钟的道歉视频，针对此前引发争议的一段内容作出回应。视频发布两小时后，“道歉”相关词条冲上热搜第一。",
      "视频中，博主承认自己在内容创作上存在疏忽，对受到影响的人表达了歉意，并表示会暂时停更，重新梳理自己的内容方向。语气诚恳，全程没有配乐。",
      "不过评论区的态度并没有因此统一。支持者认为愿意正面回应已经比沉默好得多；质疑者则指出，视频回避了争议的核心细节，道歉的诚意有待观察。",
      "有内容行业从业者分析，这类事件的舆论走向往往取决于后续行动。如果停更后能拿出更成熟的内容，口碑有机会慢慢修复；反之，争议很可能只是被暂时按下。",
      "截至发稿，该博主账号已设置为暂停更新状态，置顶位置保留着这条道歉视频。相关话题的讨论量仍在缓慢增长。",
    ],
  },
  {
    id: "a8",
    title: "悬疑剧结局解析冲上热榜，编剧一句话回应剧粉疑问",
    category: "影视综",
    categorySlug: "yingshi",
    excerpt:
      "大结局播出当晚，关于开放式结尾的解析贴铺满各大平台。编剧在采访里的一句话，让讨论彻底炸开。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20mystery%20drama%20scene%20with%20deep%20shadows%20and%20a%20single%20beam%20of%20light%20through%20venetian%20blinds%2C%20crimson%20red%20and%20amber%20highlights%20on%20dark%20background%2C%20cinematic%20poster%20aesthetic%2C%20film%20grain%2C%20no%20people&width=800&height=450&seq=chigua-art-08&orientation=landscape",
    heat: 188.9,
    publishedAt: "2026-09-12 11:15",
    author: "剧综点评组",
    source: "52吃瓜网综合整理",
    tags: ["悬疑剧", "大结局", "解析"],
    content: [
      "这部悬疑剧的大结局在昨晚播出，开放式结尾让观众分成两派：一派认为线索已经指向明确答案，另一派坚持画面本身就是烟雾弹。相关解析贴在几个小时内占满了首页。",
      "争议的焦点集中在大结局最后一帧。有观众逐帧分析画面中的道具位置，认为暗示了主角的选择；也有人从配乐音阶入手，得出完全相反的结论。",
      "今天上午，编剧在一档访谈节目中被问到这个问题，只回了一句话：想让大家自己选一个愿意相信的结局。这句话被截图转发后，讨论量再次飙升。",
      "有剧评人指出，开放式结局之所以容易引发长尾讨论，是因为它把解读权交给了观众，也把作品的生命周期延长了。从这个角度看，这场辩论本身就是剧集的一部分。",
      "制作方随后发布了一支幕后特辑，展示了结局场地的搭建过程，但依然没有给出标准答案。这场关于结局的讨论，看来还要持续一阵子。",
    ],
  },
  {
    id: "a9",
    title: "暴雨夜外卖小哥顺手做了件事，监控画面被全网转发",
    category: "社会奇闻",
    categorySlug: "shehui",
    excerpt:
      "一段小区监控在雨夜拍到的画面被传到网上，短短十几个小时转发过十万，评论区几乎全是同一个词：应该的。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20rainy%20night%20residential%20street%20with%20reflective%20wet%20asphalt%20and%20warm%20streetlight%20halos%2C%20teal%20green%20night%20palette%20with%20amber%20highlights%2C%20documentary%20poster%20aesthetic%2C%20soft%20grain%2C%20no%20identifiable%20people&width=800&height=450&seq=chigua-art-09&orientation=landscape",
    heat: 143.1,
    publishedAt: "2026-09-11 20:55",
    author: "社区观察",
    source: "52吃瓜网综合整理",
    tags: ["暖心", "城市", "见闻"],
    content: [
      "昨晚一场暴雨打乱了某小区的节奏。一段监控画面显示，一位外卖骑手在送单途中停下电动车，把被大风吹倒的垃圾桶逐一扶正，又把散落的纸箱收拢到墙角，前后花了不到两分钟。",
      "这段画面被业主发到群里后，很快传到了社交平台。十几个小时里，转发量突破十万，评论区出现频率最高的词是“应该的”，有人补充说，自己也见过类似场景，只是很少被拍下来。",
      "小区物业随后在公告栏贴出了这则视频的截图，表示会在雨季增加巡查频次。有业主提议，给这位骑手点一份热饮，但因为没有留下联系方式，最终没能联系上。",
      "对这位骑手来说，这可能只是送单路上的一个小插曲。但正是这种不需要被看见的顺手之举，构成了城市里最日常的善意。",
      "有社会学者评论，这类内容的传播价值不在于制造感动，而在于提醒人们，公共空间的秩序往往由无数个微小的自觉动作共同维持。",
    ],
  },
  {
    id: "a10",
    title: "机场同款外套再引猜测，双方粉丝态度出奇一致",
    category: "情侣纪事",
    categorySlug: "qinglv",
    excerpt:
      "两人先后出现在不同城市的机场，身上的外套被网友认出是同款。这次粉丝的反应，和以往很不一样。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20airport%20terminal%20interior%20at%20dusk%20with%20large%20windows%20and%20soft%20sky%20gradient%2C%20warm%20coral%20and%20cream%20tones%2C%20minimal%20editorial%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20no%20people&width=800&height=450&seq=chigua-art-10&orientation=landscape",
    heat: 118.4,
    publishedAt: "2026-09-11 15:40",
    author: "瓜田记录",
    source: "52吃瓜网综合整理",
    tags: ["同款", "机场", "粉丝"],
    content: [
      "本周内，两人先后被拍到出现在不同城市的机场，身上的外套款式一致，只是颜色不同。相关对比图在粉丝群体中迅速传开，猜测也随之升温。",
      "有意思的是，这一次双方粉丝的反应出奇一致。以往遇到类似话题，评论区常会出现互不相让的情况，而这次更多的留言是“别过度解读”“求关注作品”。",
      "有资深粉丝分析，这种态度转变与两人近期作品的宣传节奏有关。眼下双方都有新项目在推进，粉丝更希望讨论集中在专业表现上。",
      "截至发稿，双方均未就同款外套作出任何回应。有造型师在评论区科普，同款服装在艺人团队之间借用并不罕见，单凭服装很难作为判断依据。",
      "无论如何，这条话题的讨论量已经明显低于此前几次传闻。有网友总结：粉丝长大了，吃瓜也变得更克制了。",
    ],
  },
  {
    id: "a11",
    title: "颁奖礼红毯造型盘点，这一套被网友称为全场最佳",
    category: "娱乐八卦",
    categorySlug: "yule",
    excerpt:
      "红毯结束后，各平台的造型盘点陆续上线。在一众华服里，一套看似低调的造型拿下了最高讨论度。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20red%20carpet%20gala%20scene%20with%20tall%20spotlights%20and%20golden%20confetti%20bokeh%2C%20deep%20crimson%20and%20amber%20gold%20palette%2C%20luxury%20awards%20poster%20aesthetic%2C%20soft%20vignette%2C%20no%20people&width=800&height=450&seq=chigua-art-11&orientation=landscape",
    heat: 165.7,
    publishedAt: "2026-09-10 23:30",
    author: "吃瓜观察员",
    source: "52吃瓜网综合整理",
    tags: ["红毯", "造型", "颁奖礼"],
    content: [
      "昨晚的颁奖礼红毯持续了近两个小时，各平台在结束后迅速上线造型盘点。在一众华丽礼服中，一套剪裁利落、几乎没有装饰的造型意外拿下了最高讨论度。",
      "造型师在后续采访中透露，这套方案前后修改了五版，最终决定做减法，把重点放在面料的光泽和肩线比例上。结果证明，这个判断是对的。",
      "相比之下，几套元素堆叠较多的造型评价出现了分歧。有网友认为红毯需要记忆点，也有网友觉得元素过多反而模糊了重点。",
      "从传播数据看，讨论度最高的三套造型分别代表了三种思路：极简、复古和戏剧化。没有哪一种风格获得压倒性优势，这也让今年的红毯讨论格外热闹。",
      "业内人士表示，红毯造型的本质是一次公开的审美表达，成败往往不在于贵重与否，而在于是否和本人的气质、当晚的身份定位相匹配。",
    ],
  },
  {
    id: "a12",
    title: "带货直播间数据被扒，商家连夜发声明说明情况",
    category: "网红动态",
    categorySlug: "wanghong",
    excerpt:
      "有网友根据直播回放统计了某场带货的成交数据，与宣传口径存在出入。相关商家在凌晨发布了一份说明。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20ecommerce%20data%20dashboard%20scene%20with%20glowing%20charts%20and%20floating%20numbers%2C%20coral%20red%20and%20forest%20green%20accents%20on%20cream%20background%2C%20modern%20editorial%20infographic%20style%2C%20clean%20minimal%2C%20no%20people&width=800&height=450&seq=chigua-art-12&orientation=landscape",
    heat: 132.8,
    publishedAt: "2026-09-10 09:05",
    author: "瓜田记录",
    source: "52吃瓜网综合整理",
    tags: ["带货", "数据", "声明"],
    content: [
      "日前，有网友根据一场带货直播的回放，逐条统计了下单提示出现的次数，并与宣传中提到的高成交数据做了对比，指出两者之间存在明显出入。",
      "这篇统计帖发布后迅速发酵。有品牌方跟帖表示，自己也对当场的转化情况存疑，正在核对后台数据。相关话题在当晚登上多个平台的讨论榜。",
      "今天凌晨，参与该场直播的商家发布了一份说明，称宣传口径中的数字包含预售与后续复购，与直播当场的即时成交并非同一统计维度，造成了理解上的差异。",
      "声明同时表示，会在一周内公布更详细的数据口径说明，并邀请第三方机构进行核对。截至发稿，主播团队尚未就此单独回应。",
      "有电商从业者表示，带货数据的统计口径长期缺乏统一标准，类似的争议并不少见。对消费者而言，与其纠结数字，不如关注商品本身的口碑与售后。",
    ],
  },
];

